import React from "react";
import styles from "./parent-guardian-info.module.css";
import { Col, Divider, Row, Typography } from "antd";
import CustomButton from "../../../../../../../../common/custom-button/custom-button";
import SVGIcon from "../../../../../../../../constants/SVGIcon";
import { toast } from "react-toastify";
import { resendCredentialsParents } from "../../../../../../../../services/student";

const ParentGuardianInfo = ({
  data,
  title,
  full_name,
  occupation,
  phone_number,
  relationship,
  address,
  email,
  handleEditDetails,
  parentId,
  reg_no,
}) => {
  const handleResendCredentials = async (parentId) => {
    try {
      await resendCredentialsParents({
        parent_id: parentId,
      });
      toast.success("Resend is Successful");
    } catch (err) {
      toast.success("Error in Resending Credentials");
    }
  };

  const parentFields = [
    { label: "Full Name", value: full_name },
    { label: "Relationship", value: relationship },
    { label: "Occupation", value: occupation },
    { label: "Address", value: address },
    { label: "Phone no", value: phone_number },
    { label: "Email", value: email },
    { label: "Reg No", value: reg_no },
  ];

  return (
    <Col className={styles.parent_guardian_info}>
      <Divider
        orientation="left"
        orientationMargin="0"
        style={{ margin: "0px 0" }}
      >
        <Typography className={styles.dividerTitle}>{title}</Typography>
      </Divider>
      <Row gutter={[0, 10]}>
        {parentFields?.map((field, fieldIndex) => (
          <Col md={24} lg={12}>
            <div key={fieldIndex} className={styles.informationContainer}>
              <Typography className={styles.infoLabelClass}>{field?.label}:</Typography>
              <div className={styles.valueWrapper}>
                <Typography className={styles.infoValueClass}>
                  {field?.value || "-"}
                </Typography>
              </div>
            </div>
          </Col>
        ))}
      </Row>
      <Col className={styles.buttons_container}>
        <CustomButton
          title="Resend Credentials"
          size={"large"}
          className="anticon"
          onClick={() => {
            handleResendCredentials(parentId);
          }}
        />
        <CustomButton
          title="Edit Details"
          size={"large"}
          icon={
            <SVGIcon
              name={"edit-icon-pencil"}
              width={"16"}
              height={"16"}
              className="anticon"
              stroke={"#FFF"}
            />
          }
          onClick={() => handleEditDetails(data)}
        />
      </Col>
    </Col>
  );
};

export default ParentGuardianInfo;
